import styled from "styled-components";
import { TableCell, TableRow } from "@mui/material";

export const StyledTableCell = styled(TableCell)<{ $center?: boolean; $header?: boolean }>`
    color: var(--color-grey-900);

    ${({ $header }) =>
        $header &&
        `
        text-transform: uppercase;
    `}

    ${({ $center }) =>
        $center &&
        `
        text-align: center;
    `}
`;

export const StyledTableCellName = styled(TableCell)`
    font-size: var(--size-16);
    font-weight: var(--weight-600);
    color: var(--color-primary);
    display: flex;
    column-gap: 10px;
    align-items: center;
`;

export const StyledTableRow = styled(TableRow)<{ $pending: boolean }>`
    border-bottom: none;

    ${({ $pending }) =>
        $pending &&
        `
        cursor: default;
        background-color: var(--color-pending);
    `}
`;
